<script>
  /* global Global */
  import SmallTitle from '../common/SmallTitle.svelte';
  import TwButtonPrimary from '../tailwind/TwButtonPrimary.svelte';
  import TwButtonSecondary from '../tailwind/TwButtonSecondary.svelte';
  import TwSelectMenu from '../tailwind/TwSelectMenu.svelte';

  export let page;
  export let selectedYear;
  export let years = [];
  export let lang = undefined;

  const yearsButtons = years.filter((_, idx) => idx < 3);
  const yearsSelect = years.filter((_, idx) => idx >= 3);

  let yearSelect = yearsSelect.includes(selectedYear) ? selectedYear : 'older';

  $: if (yearSelect !== 'older') window.location.href = `./#/${page.replace(':year', yearSelect)}`;

  const projectName = Global.project.name;
  const yearsLength = Global.years.length;
</script>

{#if yearsLength > 1}
  <div class='years-select'>
    <div class='years-select-small-title'>
      <SmallTitle value={`${projectName[lang]} ${selectedYear}`}/>
    </div>

    <div class='years-select-controls'>
      {#each yearsButtons as year}
        {#if year === selectedYear}
          <TwButtonPrimary value={year}/>
        {:else}
          <TwButtonSecondary value={year} onClick={() => { window.location.href = `./#/${page.replace(':year', year)}`; }}/>
        {/if}
      {/each}

      {#if yearsSelect.length > 0}
        <div class='years-select-controls-older'>
          <TwSelectMenu bind:value={yearSelect} elements={[{ value: 'older', label: { cs: 'Starší', en: 'Older' } }, ...yearsSelect.map(value => ({ value: value, label: { cs: value, en: value } }))]} bind:lang active={yearSelect !== 'older'}/>
        </div>
      {/if}
    </div>
  </div>
{/if}


<style>
  .years-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    height: 40px;
  }

  .years-select-small-title {
    flex-grow: 1;
  }

  .years-select-controls {
    display: flex;
    gap: 10px;
  }

  .years-select-controls-older {
    width: 100px;
  }

  @media only screen and (max-width: 850px) {
    .years-select {
      justify-content: flex-end;
    }

    .years-select-small-title {
      display: none;
    }
  }
</style>
